






































































































































































import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Validator } from 'vee-validate';

import Input from '@/shared/components/Inputs/Input.vue';
import Field from '@/shared/components/Field/Field.vue';

import { getZipCode, getCitiesFromState } from '@/api/resources/address';

import Address from '@/classes/Address';

import { IAddress } from '@/interfaces/Address';
import { IStates } from '@/interfaces/States';
import { ICities } from '@/interfaces/Cities';

const BRState = require('@/shared/json/state.json');

@Component({
  components: {
    Input,
    Field,
  },
})
export default class AddressComponent extends Vue {
  @Prop({ required: true })
  private validator: Validator;

  @Prop()
  private value: IAddress;

  @Prop({ default: false })
  private readonly showFormWithoutZipCodeData?: boolean;

  @Prop({ default: false })
  private readonly notSendInput: boolean;

  private zipCodeLoading = false;
  private existZipCode = true;
  private states: Array<IStates> = BRState.state;
  private cities: Array<ICities> = [];
  private loadingCities = false;

  private onPostalCodeChange (value: string, oldValue: string) {
    this.value.postal_code = value;
    value = value.replace(/\D/g, '');

    if (value && value.length > 7) {
      this.validator.validate('postal_code', value);
    }

    if (value && value.length > 7 && value !== oldValue) {
      this.zipCodeLoading = true;

      getZipCode(value)
        .then((response: any) => {
          const address: IAddress = response.data;
          this.zipCodeLoading = false;

          if (address.postal_code.replace('-', '') == value.replace('-', '')) {
            const newAddress = new Address({ ...address, zipCodeData: true });
            !this.notSendInput && this.$emit('input', newAddress);
            this.$emit('fromZipCode', newAddress);
            this.existZipCode = true;
          } else {
            this.value.zipCodeData = false;
            this.validator.validate('postal_code', '0');
          }
        })
        .catch(e => {
          !this.notSendInput && this.$emit(
            'input',
            new Address({ ...this.value, zipCodeData: true }),
          );

          this.$emit('fromZipCode', new Address({ ...this.value, zipCodeData: true }));
          this.$emit('zipCodeNotFound');
          this.zipCodeLoading = false;
          this.existZipCode = false;
          this.validator.validate('postal_code', '0');
        });
    } else if (value.length == 0) {
      this.$emit('input', new Address({ ...this.value, zipCodeData: false }));
    }
  }

  private onSelectState(state: string) {
    this.loadingCities = true;
    this.validator.validate('state', state);
    getCitiesFromState(state).then((response: any) => {
      this.cities = response.data;
      this.loadingCities = false;
    });
  }

  private change(input: string) {
    this.validator.validate(input, (this.$refs[input] as any).value);
  }

  private createValidations() {
    this.validator.attach({
      name: 'postal_code',
      rules: 'required|min:8',
    });

    this.validator.attach({
      name: 'street_name',
      rules: 'required',
    });

    this.validator.attach({
      name: 'street_number',
      rules: 'required',
    });

    this.validator.attach({
      name: 'neighborhood',
      rules: 'required',
    });

    this.validator.attach({
      name: 'state',
      rules: 'required',
    });

    this.validator.attach({
      name: 'city',
      rules: 'required',
    });
  }

  onZipCodeFocus() {
    setTimeout(() => {
      (this.$refs.zipCodeContainer as any).scrollIntoView({ block: 'nearest' });
    }, 150);
  }

  private mounted() {
    this.createValidations();
  }
}
